import { render, staticRenderFns } from "./Kunjungan.vue?vue&type=template&id=a61b5926&"
import script from "./Kunjungan.vue?vue&type=script&lang=js&"
export * from "./Kunjungan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports